"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Record } from "immutable";
import { AppDispatcher } from 'Dispatcher';
import { d5TableOnMasterChanged } from "Actions/Table/D5TableActions";
var MASTER_CHANGED = 'MASTER_CHANGED';
var MASTER_DETAIL_REINIT = 'MASTER_DETAIL_REINIT';
export var DetailStore = Record({
  tableID: null,
  masterID: null,
  masterObjectName: null,
  detailField: null,
  masterField: null,
  masterKeyField: null,
  filter: {}
});

var MasterDetailClass =
/*#__PURE__*/
function () {
  function MasterDetailClass() {
    _classCallCheck(this, MasterDetailClass);

    _defineProperty(this, "tables", new Map());
  }

  _createClass(MasterDetailClass, [{
    key: "clear",
    value: function clear() {
      this.tables.clear();
    }
    /**
     * @param key
     * @return {DetailStore}
     */

  }, {
    key: "getTable",
    value: function getTable(key) {
      return this.tables.get(key);
    }
    /**
     * @param masterKey
     * @param objID
     * @param rowData
     */

  }, {
    key: "onMasterChanged",
    value: function onMasterChanged() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          masterKey = _ref.masterKey,
          objID = _ref.objID,
          rowData = _ref.rowData;

      this.updateDetails(masterKey, objID, rowData);
    }
    /**
     * @param key
     * @param {DetailStore} table
     */

  }, {
    key: "setTable",
    value: function setTable(key, table) {
      this.tables = this.tables.set(key, table);
    }
    /**
     * @param {DetailStore} detail
     * @param masterObjID
     * @param rowData
     */

  }, {
    key: "updateDetail",
    value: function updateDetail(detail, masterObjID, rowData) {
      var masterField = detail.get('masterField'),
          tableID = detail.get('tableID'),
          detailField = detail.get('detailField');

      var filter = _defineProperty({}, detailField, rowData[masterField]);

      this.setTable(tableID, detail.set('filter', filter));
      d5TableOnMasterChanged({
        formID: tableID,
        filter: filter
      });
    }
    /**
     * @param masterKey
     * @param masterObjID
     * @param rowData
     */

  }, {
    key: "updateDetails",
    value: function updateDetails(masterKey, masterObjID, rowData) {
      var _this = this;

      this.tables.forEach(function (detail) {
        if (detail.get('masterID') === masterKey) _this.updateDetail(detail, masterObjID, rowData);
      });
    }
  }]);

  return MasterDetailClass;
}();

export var MasterDetail = new MasterDetailClass(); //------------------Dispatcher

AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case MASTER_CHANGED:
      MasterDetail.onMasterChanged(action.options);
      break;

    case MASTER_DETAIL_REINIT:
      MasterDetail.clear();
      break;

    default:
      return true;
  }
}); //----------------Actions

export function masterChanged(options) {
  AppDispatcher.asyncDispatch({
    actionType: MASTER_CHANGED,
    options: options
  });
}
export function masterDetailReinit() {
  AppDispatcher.asyncDispatch({
    actionType: MASTER_DETAIL_REINIT
  });
}